// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wduvqerkhfozcedhqkfq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndkdXZxZXJraGZvemNlZGhxa2ZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2MDI1MjgsImV4cCI6MjA1ODE3ODUyOH0._KEdvrXBcoDVe1QLwdEDKJQ4Hy_cIyJQ722d8aFJKU4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);